import { Icon, IconProps, useThemeValues } from '@frontend/design-system';

type Props = IconProps & {
  fillRatio?: number;
};

export const GoogleStarIcon = ({ size = 16, fillRatio, ...props }: Props) => {
  const theme = useThemeValues();

  const colors = {
    orange: '#EABF5A',
    gray: theme.name === 'original' ? theme.colors.gray400 : theme.colors.neutral20,
  };

  return (
    <Icon viewBox={'0, 0, 17, 16'} size={size} {...props}>
      <defs>
        <linearGradient id={'grad' + fillRatio}>
          <stop offset='0' stopColor={colors.orange} />
          <stop offset={fillRatio} stopColor={colors.orange} />
          <stop offset={fillRatio} stopColor={colors.gray} />
          <stop offset='1' stopColor={colors.gray} />
        </linearGradient>
      </defs>
      <path
        d='M8.568 0l2.266 5.449 5.883.471-4.482 3.84 1.37 5.74-5.037-3.076L3.532 15.5l1.37-5.74L.418 5.92l5.883-.471L8.568 0z'
        fill={`url(#grad${fillRatio})`}
      />
    </Icon>
  );
};
